// observe tablesaw mutation, replace b tags with p tags
(function(){
    var theTable = document.getElementsByClassName('tablesaw')[0];
    
    if(!theTable){
        return;
    }

    var config = {
        attributes: false,
        childList: true,
        subtree: true
    };

    function cb(mutationsList) {
        for (var i = 0; i < mutationsList.length; i++) {
            if (mutationsList[i].addedNodes.length == 0) {
                continue;
            }
            if (mutationsList[i].addedNodes[0].tagName == "B") {
                var oldTag = mutationsList[i].addedNodes[0];
                var pTag = document.createElement("p");
                pTag.innerHTML = "<strong>" + oldTag.innerHTML + "</strong>";
                pTag.className = oldTag.className;
                oldTag.parentNode.replaceChild(pTag, oldTag);
            }
        }
    }
    var observer = new MutationObserver(cb);

    observer.observe(theTable, config);
})();
